module.exports = __webpack_public_path__ + "img/signup_carousel_0.966abf3b.png";